import { AxiosResponse } from "axios";
import { get, post, routes } from "api";

const auth = {
  renewAccessToken: (): Promise<AxiosResponse> => {
    return get(routes.identity.auth.renewAccessToken());
  },

  getUserSession: (): Promise<AxiosResponse> => {
    return get(routes.identity.auth.userSession());
  },

  isAuthenticated: (): Promise<AxiosResponse> => {
    return get(routes.identity.auth.isAuthenticated());
  },

  logout: (): Promise<AxiosResponse> => {
    return post(routes.identity.auth.logout());
  },
};

export default auth;
